import React, { useEffect, useState } from "react"
import { ScrollView, View } from "react-native"
import moment from "moment"

import FilledButtonM from "@common/components/button/FilledButtonM"
import TitleM from "@common/components/text/TitleM"
import { ModalM } from "@common/components/modal/ModalM"
import MobileCalendar from "./MobileCalendar"

const ISO = "YYYY-MM-DD"

const MobileDatePickerModal = ({
    visible,
    onDismiss = () => {},
    onConfirm,
    value,
    validRange,
    label,
    cancelLabel = "Annuler",
    saveLabel = "Confirmer",
}) => {
    const dateValue = value ? new Date(value) : null
    const [draft, setDraft] = useState(dateValue)

    useEffect(() => {
        if (visible) setDraft(dateValue)
    }, [visible])

    return (
        <ModalM
            visible={visible}
            onDismiss={onDismiss}
            withExitButton
            style={{
                width: "92%",
                maxWidth: 420,
                borderRadius: 12,
                padding: 0,
            }}
        >
            <ScrollView
                style={{ flexGrow: 0 }}
                contentContainerStyle={{
                    paddingHorizontal: 16,
                    paddingTop: 20,
                    paddingBottom: 20,
                }}
            >
                {label && (
                    <TitleM
                        style={{
                            textAlign: "center",
                            marginBottom: 12,
                            fontSize: 18,
                        }}
                    >
                        {label}
                    </TitleM>
                )}
                <MobileCalendar
                    value={draft}
                    min={validRange?.startDate}
                    max={validRange?.endDate}
                    onChange={setDraft}
                />
                <View
                    style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 12,
                        gap: 10,
                    }}
                >
                    <FilledButtonM
                        label={cancelLabel}
                        mode="outlined"
                        onPress={onDismiss}
                        style={{
                            flex: 1,
                            width: null,
                            paddingHorizontal: 0,
                            marginTop: 0,
                        }}
                    />
                    <FilledButtonM
                        label={saveLabel}
                        disabled={!draft}
                        onPress={() => {
                            if (!draft) return
                            onConfirm?.(moment(draft).format(ISO))
                        }}
                        style={{
                            flex: 1.6,
                            width: null,
                            paddingHorizontal: 0,
                            marginTop: 0,
                        }}
                    />
                </View>
            </ScrollView>
        </ModalM>
    )
}

export default MobileDatePickerModal
